<div
  #wrapRef
  class="wrap"
>
  <div class="wrap__container">
    <div class="container">
      <div class="container__title">
        <lib-image-title type="checkout">お会計</lib-image-title>
      </div>
      <div
        *ngIf="type === EGiftOrderType.special"
        class="container__form-gift-special"
      >
        <lib-form-gift-special
          [data]="(formGiftSpecialData$ | async) || undefined"
          (dataChange)="formGiftSpecialData$.next($event)"
          [touchEventEmitter]="touchEventEmitter"
        ></lib-form-gift-special>
      </div>
      <div
        class="container__test"
        *ngIf="!environment.production"
      >
        <lib-form-test-buttons
          *ngIf="type === EGiftOrderType.standart"
          (emailChange)="formEmailData$.next({ email: $event, email2: $event })"
          (addressChange)="formBillingAddressData$.next($event)"
          [addressDefault]="addressDefault"
        ></lib-form-test-buttons>
        <lib-form-test-buttons
          *ngIf="type === EGiftOrderType.special"
          (addressChange)="formBillingAddressData$.next($event)"
          [addressDefault]="addressDefault"
        ></lib-form-test-buttons>
      </div>
      <div class="container__form-customer-info">
        <lib-form-stripe-address
          headerTitle="請求先情報"
          headerSubtitle="このご注文をお支払いされる方"
          [data]="(formBillingAddressData$ | async) || undefined"
          (dataChange)="formBillingAddressData$.next($event)"
          [touchEventEmitter]="touchEventEmitter"
          footerTitle="※電話番号は最初の０からご記入ください"
          [regionNameEnglishDefault]="regionNameEnglishDefault"
          countryCodeDefault="JP"
          [allowedCountries]="['JP']"
          [parseStateFn]="parseStateFn"
        ></lib-form-stripe-address>
      </div>
      <div class="container__form-email">
        <lib-form-email
          #formEmailRef
          [data]="(formEmailData$ | async) || undefined"
          (dataChange)="formEmailData$.next($event)"
          [touchEventEmitter]="touchEventEmitter"
        ></lib-form-email>
      </div>
      <div class="container__ship-from">
        <lib-form-ship-from
          [value]="(shipFrom$ | async) || shipFrom$.value"
          (valueChange)="shipFrom$.next($event)"
        ></lib-form-ship-from>
      </div>
      <div
        *ngIf="type === EGiftOrderType.standart"
        class="container__form-payment"
      >
        <app-form-checkout
          [data]="{
            type: (formPaymentType$ | async) || 0
          }"
          (dataChange)="formPaymentType$.next($event.type)"
          (submit)="onSubmit()"
          [submitButtonDisabled]="(submitButtonDisabled$ | async) || false"
        ></app-form-checkout>
      </div>

      <div
        *ngIf="type === EGiftOrderType.special && alias === aliasGift"
        class="container__aliases"
      >
        <app-alias-select
          (selected)="
            restrictedAliasArr = $event; this.submitButtonDisabled$.next(false)
          "
        ></app-alias-select>
      </div>

      <div
        *ngIf="type === EGiftOrderType.special"
        class="container__submit"
      >
        <lib-button
          (buttonClick)="onSubmit()"
          [disabled]="(submitButtonDisabled$ | async) || false"
          >Submit</lib-button
        >
      </div>
    </div>
  </div>
</div>
